export const article = [
  {
    articleId: 35,
    url: "mega-go-me-cobro-dos-veces",
    category: {
      slug:"facturacion",
      name: "Facturación"
    },
    title: "Mega GO me cobró dos veces",
    content: 
      <>
        <div className="row">
          <p>Hay diferentes motivos por los que podrías ver más de un cargo de Mega GO en tu factura: </p>
        </div>
        <div className="rowLine">
          <h2>Si agregaste recientemente una forma de pago a tu cuenta</h2>
          <p>Si agregaste recientemente una forma de pago y ves más de un cargo en el mismo día, es posible que uno de los cargos sea un monto de autorización. </p>
          <p>Estas autorizaciones se utilizan para comprobar que la forma de pago sea válida.</p>
          <ul className="decimal">
            <li>Mega GO nunca recauda el importe de autorización.</li>
            <li>Se quitará automáticamente, normalmente en 8 días o menos. Confirma con tu banco la fecha en que los fondos volverán a estar disponibles en tu saldo.</li>
          </ul>
        </div>
        <div>
          <h2>Si agregaste recientemente una forma de pago a tu cuenta</h2>
          <p>Si no agregaste recientemente una forma de pago a tu cuenta y ves más de un cargo, es posible que tú o alguien que use tu cuenta hayan iniciado otra cuenta por error.</p>
          <p>Si te ocurre esto, comunícate con nosotros.</p>
        </div>
      </>
  }
];